module.exports = __webpack_public_path__ + "static/media/cu.71eea529.png";